import './style.scss';
import apiFetch from '@wordpress/api-fetch';

// Deconstructing the configuration object for easier access to its properties
const { rest } = UncannyAutomatorTooltipNotification;

// Add the nonce as middleware. This automatically adds the `X-WP-Nonce` header to requests.
apiFetch.use( apiFetch.createNonceMiddleware( rest.nonce ) );

/**
 * TooltipNotification class to handle tooltip behavior.
 */
class TooltipNotification {
	/**
	 * Constructor initializes tooltip notifications.
	 */
	constructor() {
		this.tooltips = document.querySelectorAll( '.uap-tooltip-notification' );
		this.initializeTooltips();
	}

	/**
	 * Initializes all tooltips on the page.
	 */
	initializeTooltips() {
		this.tooltips.forEach( tooltipElement => {
			this.initializeTooltip( tooltipElement );
		} );
	}

	/**
	 * Initializes a single tooltip's functionality.
	 *
	 * @param {HTMLElement} tooltipElement - The tooltip element to initialize.
	 */
	initializeTooltip( tooltipElement ) {
		const closeButton = tooltipElement.querySelector( '.uap-tooltip-notification__close' );

		// Position the tooltip correctly in the DOM
		this.positionTooltip( tooltipElement );

		// Show the tooltip
		this.showTooltip( tooltipElement );

		// Handle close button click
		closeButton.addEventListener( 'click', ( e ) => {
			e.preventDefault();

			this.hideTooltip( tooltipElement, tooltipElement.dataset.id );
		} );
	}

	/**
	 * Shows the tooltip.
	 *
	 * @param {HTMLElement} tooltipElement - The tooltip element to show.
	 */
	showTooltip( tooltipElement ) {
		tooltipElement.classList.remove( 'uap-tooltip-notification--hidden' );
	}

	/**
	 * Hides the tooltip and sends an AJAX request to mark it as hidden.
	 *
	 * @param {HTMLElement} tooltipElement - The tooltip element to hide.
	 * @param {String} tooltipId - The ID of the tooltip.
	 */
	hideTooltip( tooltipElement, tooltipId ) {
		tooltipElement.classList.add( 'uap-tooltip-notification--hidden' );

		// Send API request to mark the tooltip as hidden
		apiFetch( {
			url: `${ rest.url }/tooltip-notification/tooltip_id/${ tooltipId }/tooltip_action/hide/`,
			method: 'POST',
		} )
			.then( response => console.log( response ) )
			.catch( error => console.warn( error ) );
	}

	/**
	 * Positions the tooltip correctly in the DOM based on the provided selector and position.
	 *
	 * @param {HTMLElement} tooltipElement - The tooltip element to position.
	 */
	positionTooltip( tooltipElement ) {
		const targetElement = document.querySelector( tooltipElement.dataset.target );

		if ( targetElement ) {
			targetElement.insertAdjacentElement( tooltipElement.dataset.position, tooltipElement );

			// Calculate top position
			let topPosition = targetElement.offsetHeight / 2 - tooltipElement.offsetHeight / 2;

			// Adjust top position only if the tooltip is placed before or after the target element
			if ( [ 'beforebegin', 'afterend' ].includes( tooltipElement.dataset.position ) ) {
				topPosition += targetElement.offsetTop;
			}

			tooltipElement.style.top = `${ topPosition }px`;
		}
	}
}

// Initialize tooltip notifications on DOMContentLoaded
document.addEventListener( 'DOMContentLoaded', () => {
	new TooltipNotification();
} );